import React, { FC } from 'react';

import { withTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { ThemeProps, variant } from '@lucid/theme';

export type NavbarBrandVariants = 'default';

export interface NavbarBrandProps {
  /** Allows the component to get additional styles. */
  className?: string;
  /** The theme object to apply styles to the NavbarBrand component. */
  theme: ThemeProps['theme'];
  /** The available variants for the NavbarBrand component. */
  variant?: NavbarBrandVariants;
}

const StyledNavbarBrand = styled.div<NavbarBrandProps>((
  { theme }
) => (
  {
    label: 'navbarBrand',
    display: 'flex',
    alignItems: 'center',
    [`@media (max-width: ${theme.navbar.collapseAt})`]: {
      padding: 0,
      margin: 'auto 0'
    }
  }),
variant({
  scale: 'navbar.brand',
  variants: {
    defaultVariants: {}
  }
})
);

const NavbarBrandWrapper: FC<NavbarBrandProps> = ({
  className,
  variant = 'default',
  ...rest
}) => (
  <StyledNavbarBrand
    {...rest}
    className={className}
    variant={variant}
  />
);

const NavbarBrand = withTheme(NavbarBrandWrapper);

export { NavbarBrand };
export default NavbarBrand;
